import React, { useState, useEffect } from 'react';
import Card from '../components/ui/Card';
import Button from '../components/ui/Button';
import { requestService } from '../services/requestService';
import './Validation.css';

const Validation = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('all');
  const [selectedOffer, setSelectedOffer] = useState('all');
  const [selectedCompany, setSelectedCompany] = useState('all');



  const fetchRequests = async () => {
  try {
    setLoading(true);
    setError('');
    
    console.log('🔄 Fetching requests with filters:', {
      status: selectedStatus !== 'all' ? selectedStatus : null,
      offer: selectedOffer !== 'all' ? selectedOffer : null,
      company: selectedCompany !== 'all' ? selectedCompany : null // 🆕
    });
    
    const response = await requestService.getAdminRequests(
      selectedStatus !== 'all' ? selectedStatus : null,
      selectedOffer !== 'all' ? selectedOffer : null,
      selectedCompany !== 'all' ? selectedCompany : null // 🆕
    );
    
    console.log('✅ API Responses:', response);
    setRequests(response || []);
    
  } catch (err) {
    console.error('❌ API Error:', err);
    setError(err.message || 'Erreur lors du chargement des demandes');
    setRequests([]);
  } finally {
    setLoading(false);
  }
};


  // Chargement initial
  useEffect(() => {
    fetchRequests();
  }, []);

  // Rechargement quand les filtres changent
  useEffect(() => {
    fetchRequests();
  }, [selectedStatus, selectedOffer ,selectedCompany]);

  // Valider une demande
  const handleApproveRequest = async (requestId) => {
    try {
      setError('');
      await requestService.approveRequest(requestId);
      
      // Mettre à jour l'état local
      setRequests(prev => prev.filter(req => req._id !== requestId));
      
      // Recharger les données
      await fetchRequests();
      
    } catch (err) {
      setError('Erreur lors de la validation de la demande');
      console.error('Erreur approve request:', err);
    }
  };

  // Rejeter une demande
  const handleRejectRequest = async (requestId) => {
    try {
      setError('');
      await requestService.rejectRequest(requestId);
      
      // Mettre à jour l'état local
      setRequests(prev => prev.filter(req => req._id !== requestId));
      
      // Recharger les données
      await fetchRequests();
      
    } catch (err) {
      setError('Erreur lors du rejet de la demande');
      console.error('Erreur reject request:', err);
    }
  };

  // Obtenir le statut avec style
  const getStatusInfo = (status) => {
    const statusConfig = {
      pending: { label: 'En attente', color: '#FF9800', bgColor: 'rgba(255, 152, 0, 0.1)', icon: '⏳' },
      approved: { label: 'Approuvée', color: '#20C997', bgColor: 'rgba(32, 201, 151, 0.1)', icon: '✅' },
      rejected: { label: 'Rejetée', color: '#FF6B6B', bgColor: 'rgba(255, 107, 107, 0.1)', icon: '❌' },
      completed: { label: 'Terminée', color: '#667eea', bgColor: 'rgba(102, 126, 234, 0.1)', icon: '🎯' }
    };
    return statusConfig[status] || statusConfig.pending;
  };

  // Formater la date
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Extraire les offres uniques pour le filtre
  const uniqueOffers = [...new Map(requests.map(req => [req.offer._id, req.offer])).values()];
// Extraire les entreprises uniques pour le filtre
const uniqueCompanies = [...new Map(
  requests
    .filter(req => req.user && req.user.company) // Filtrer celles qui ont une entreprise
    .map(req => [req.user.company._id, req.user.company])
).values()];


  if (loading) {
    return (
      <div className="validation">
        <div className="page-header">
          <div className="page-title">
            <h1>Validation des Demandes</h1>
            <p>Chargement...</p>
          </div>
        </div>
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <p>Chargement des demandes...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="validation">
      {/* En-tête de page */}
      <div className="page-header">
        <div className="page-title">
          <h1>Validation des Demandes</h1>
          <p>Traitez les demandes de vos employés</p>
        </div>
        
        <div className="header-actions">
          <div className="filters">
            <select 
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
              className="filter-select"
            >
              <option value="all">📋 Tous les statuts</option>
              <option value="pending">⏳ En attente</option>
              <option value="approved">✅ Approuvées</option>
              <option value="rejected">❌ Rejetées</option>
              <option value="completed">🎯 Terminées</option>
            </select>

            <select 
              value={selectedOffer}
              onChange={(e) => setSelectedOffer(e.target.value)}
              className="filter-select"
            >
              <option value="all">🎁 Toutes les offres</option>
              {uniqueOffers.map(offer => (
                <option key={offer._id} value={offer._id}>
                  {offer.title}
                </option>
              ))}
            </select>


            <select 
      value={selectedCompany}
      onChange={(e) => setSelectedCompany(e.target.value)}
      className="filter-select"
    >
      <option value="all">🏢 Toutes les entreprises</option>
      {uniqueCompanies.map(company => (
        <option key={company._id} value={company._id}>
          🏢 {company.name}
        </option>
      ))}
    </select>


    <Button 
  variant="secondary" 
  size="sm"
  onClick={() => {
    setSelectedStatus('all');
    setSelectedOffer('all');
    setSelectedCompany('all');
  }}
  className="reset-filters-btn"
>
  🔄 Réinitialiser
</Button>
          </div>
        </div>
      </div>

      {/* Message d'erreur */}
      {error && (
        <Card className="error-card" padding="md">
          <div className="error-message">
            <span>❌</span>
            {error}
            <button onClick={() => setError('')} className="error-close">✕</button>
          </div>
        </Card>
      )}

      {/* Statistiques rapides */}
      <div className="validation-stats">
        <Card className="stat-card" padding="lg">
          <div className="stat-content">
            <div className="stat-icon">📋</div>
            <div className="stat-info">
              <div className="stat-number">{requests.length}</div>
              <div className="stat-label">Total des demandes</div>
            </div>
          </div>
        </Card>
        
        <Card className="stat-card" padding="lg">
          <div className="stat-content">
            <div className="stat-icon">⏳</div>
            <div className="stat-info">
              <div className="stat-number">
                {requests.filter(req => req.status === 'pending').length}
              </div>
              <div className="stat-label">En attente</div>
            </div>
          </div>
        </Card>
        
        <Card className="stat-card" padding="lg">
          <div className="stat-content">
            <div className="stat-icon">✅</div>
            <div className="stat-info">
              <div className="stat-number">
                {requests.filter(req => req.status === 'approved').length}
              </div>
              <div className="stat-label">Approuvées</div>
            </div>
          </div>
        </Card>

        <Card className="stat-card" padding="lg">
          <div className="stat-content">
            <div className="stat-icon">❌</div>
            <div className="stat-info">
              <div className="stat-number">
                {requests.filter(req => req.status === 'rejected').length}
              </div>
              <div className="stat-label">Rejetées</div>
            </div>
          </div>
        </Card>
      </div>

      {/* Grille des demandes */}
      <div className="requests-grid">
        {requests.map(request => {
          const { offer, user } = request;
          const statusInfo = getStatusInfo(request.status);
          
          return (
            <Card key={request._id} className="request-card" padding="lg">
              {/* En-tête de la demande */}
              <div className="request-header">
                <div className="request-employee">
                  <span className="employee-icon">👤</span>
                  <span className="employee-name">
                    {user.firstName} {user.lastName}
                  </span>
                </div>
                <div className="request-badges">
                  <span className={`status-badge ${request.status}`}>
                    {statusInfo.icon} {statusInfo.label}
                  </span>
                </div>
              </div>

              {/* Informations de l'offre */}
              <div className="request-title-section">
                <h3 className="request-title">{offer.title}</h3>
                <div className="offer-code">
                  <span className="code-label">OFFRE:</span>
                  <span className="code-value">{offer.codeOffre}</span>
                </div>
              </div>

              {/* Description de l'offre */}
              <p className="request-description">{offer.description}</p>

              {/* Détails de la demande */}
              <div className="request-details">
                <div className="detail-row">
                  <span className="detail-label">Employé:</span>
                  <span className="detail-value">
                    {user.firstName} {user.lastName} ({user.employeeId})
                  </span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Email:</span>
                  <span className="detail-value">{user.email}</span>
                </div>


                  {user.company && (
    <div className="detail-row">
      <span className="detail-label">Entreprise:</span>
      <span className="detail-value">
        🏢 {user.company.name}
      </span>
    </div>
  )}

                <div className="detail-row">
                  <span className="detail-label">Date demande:</span>
                  <span className="detail-value">{formatDate(request.createdAt)}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Type offre:</span>
                  <span className="detail-value">{offer.type}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Partenaire:</span>
                  <span className="detail-value">{offer.partnerName}</span>
                </div>
              </div>

              {/* Données du formulaire */}
              {request.formData && Object.keys(request.formData).length > 0 && (
                <div className="justification-section">
                  <div className="justification-header">
                    <span className="justification-label">📝 Informations supplémentaires:</span>
                  </div>
                  <div className="justification-text">
                    {Object.entries(request.formData).map(([key, value]) => (
                      <div key={key} style={{ marginBottom: '8px' }}>
                        <strong>{key}:</strong> {value}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Montant si disponible */}
              {request.formData?.amount && (
                <div className="amount-section">
                  <div className="amount-info">
                    <span className="amount-label">💰 Montant sollicité:</span>
                    <span className="amount-value">{request.formData.amount}DA</span>
                  </div>
                </div>
              )}

              {/* Actions selon le statut */}
              <div className="request-actions">
                { (
                  <>
                    <Button 
                      variant="primary" 
                      size="sm"
                      className="approve-btn"
                      onClick={() => handleApproveRequest(request._id)}
                    >
                      ✅ Approuver
                    </Button>
                    <Button 
                      variant="secondary" 
                      size="sm"
                      className="reject-btn"
                      onClick={() => handleRejectRequest(request._id)}
                    >
                      ❌ Rejeter
                    </Button>
                  </>
                )}
                
              </div>
            </Card>
          );
        })}
      </div>

      {/* État vide */}
      {requests.length === 0 && !loading && (
        <Card className="empty-state">
          <div className="empty-icon">
            {selectedStatus === 'pending' ? '⏳' : 
             selectedStatus === 'approved' ? '✅' :
             selectedStatus === 'rejected' ? '❌' : '📋'}
          </div>
          <h3 className="empty-title">
            {selectedStatus === 'pending' ? 'Aucune demande en attente' :
             selectedStatus === 'approved' ? 'Aucune demande approuvée' :
             selectedStatus === 'rejected' ? 'Aucune demande rejetée' :
             'Aucune demande trouvée'}
          </h3>
          <p className="empty-text">
            {selectedStatus === 'pending' 
              ? "Toutes les demandes ont été traitées ou aucune demande n'est en attente de validation"
              : "Aucune demande ne correspond aux critères sélectionnés"
            }
          </p>
          <Button 
            variant="primary"
            onClick={() => {
              setSelectedStatus('all');
              setSelectedOffer('all');
            }}
          >
            📋 Voir toutes les demandes
          </Button>
        </Card>
      )}
    </div>
  );
};

export default Validation;